export default class AnimationScrollPage {
  constructor() {
    this.$el = $('.animation');
    this.addClassAni = 'set-animation';
    this.splitDone = false;
    this.observer = null;
  }

  async init() {
    if (!this.splitDone) {
      this.$el = $('.animation');
      this.splitDone = true;
    }
    this.createObserver();
    this.observe(this.$el.toArray());

    // Re-check after all resources load — images may shift layout after fonts.ready,
    // causing in-viewport elements to be missed on the initial pass.
    window.addEventListener('load', () => this.observe(this.$el.toArray()), { once: true });
  }

  createObserver() {
    if (this.observer) this.observer.disconnect();

    // Fine-grained thresholds so callback fires often enough to catch the exact 50% point
    const thresholds = Array.from({ length: 21 }, (_, i) => i * 0.05);

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const elH = entry.boundingClientRect.height;
          const vH = entry.rootBounds ? entry.rootBounds.height : window.innerHeight;

          // Large viewport → need more element visible before firing (fire later).
          // Small viewport → fire earlier (element fills more of screen anyway).
          // Maps: vH ≤ 400px → 15%, vH = 900px → 45%, capped at 50%.
          const elementRatio = Math.max(0.10, Math.min(0.30, 0.10 + (vH - 400) / 500 * 0.20));
          const targetPx = Math.min(elH * elementRatio, vH * 0.5);

          if (entry.intersectionRect.height >= targetPx) {
            const el = entry.target;
            $(el).addClass(this.addClassAni);
            this.observer.unobserve(el);
          }
        });
      },
      { threshold: thresholds },
    );
  }

  observe(elements) {
    const vH = window.innerHeight;

    elements.forEach((el) => {
      if ($(el).hasClass(this.addClassAni)) return;
      const rect = el.getBoundingClientRect();

      // Completely outside viewport — hand off to IntersectionObserver, which
      // applies its own threshold once the element scrolls into view.
      if (rect.bottom <= 0 || rect.top >= vH) {
        this.observer.observe(el);
        return;
      }

      // Already partially or fully in the viewport at the moment this check
      // runs (initial load, or a later layout change) — its "enter" moment
      // already happened before any animation could play, so reveal it
      // immediately. Gating this on a visibility ratio (as before) left tall
      // sections that straddle the initial fold — e.g. Location Listing —
      // stuck invisible until the user scrolled further, showing as a blank
      // gap even though part of the section was already on screen.
      $(el).addClass(this.addClassAni);
    });
  }

  refresh() {
    this.observe($('.animation').toArray());
  }
}

const animationScrollPage = new AnimationScrollPage();
animationScrollPage.init();

window.animationScrollPage = animationScrollPage;

window.addEventListener('page-layout-change', () => {
  animationScrollPage.refresh();
});
